//@flow
import { takeLatest, call, put } from 'redux-saga/effects'
import { sagaHandleError } from '../../helpers'
import { sagaGet } from '../../fetch/index'
import { updateResultsInAnalyticsStore } from '../../stores/analytics'
import { API_POLLS_ENGAGEMENT_URL } from '../../urls.js'
import type { FluxStandardAction } from '../../types'
import { sagaLogoutUnauthorizedUser } from '../logout'

const FETCH_ANALYTICS_IMPRESSIONS = 'opinary/FETCH_ANALYTICS_IMPRESSIONS'

const requestConfig = { headers: { Accept: 'application/json' } }

export function fetchAnalyticsImpressions(
  customerId: string,
  timeframe: Object
): FluxStandardAction {
  return {
    type: FETCH_ANALYTICS_IMPRESSIONS,
    payload: {
      customerId,
      timeframe,
    },
  }
}

// format API request to use querysStrings
const InsertQueryStrings = (url, start, end, customerId) =>
  `${url}?from=${start}&to=${end}&customer=${customerId}`

export function* sagafetchAnalyticsImpressions({
  payload,
}: {
  payload: Object,
}): Generator<*, void, *> {
  const { timeframe, customerId } = payload
  const { startDate, endDate } = timeframe

  try {
    const response = yield call(
      sagaGet,
      InsertQueryStrings(
        API_POLLS_ENGAGEMENT_URL,
        startDate,
        endDate,
        customerId
      ),
      requestConfig
    )
    if (response.status === 401 || response.status === 403)
      return yield call(sagaLogoutUnauthorizedUser)

    if (response.status === 204)
      return yield put(updateResultsInAnalyticsStore([]))

    const json = yield call([response, response.json])
    const polls = json

    yield put(updateResultsInAnalyticsStore(polls))
  } catch (error) {
    yield call(sagaHandleError, error)
  }
}

export function* sagaRepeatedlyfetchAnalyticsImpressions(): Generator<
  *,
  void,
  *
> {
  yield takeLatest(FETCH_ANALYTICS_IMPRESSIONS, sagafetchAnalyticsImpressions)
}



// WEBPACK FOOTER //
// ./src/sagas/analytics/fetchImpressions.js